/* eslint-disable */
import { filtersInfoChip } from '@/Helpers';
import { useState } from 'react';

export default function TabsWithButtons(props) {
    const { tabList, buttonList, onTabChange = () => { }, initialTab, filters, filtersInfo } = props;
    const [activeTab, setActiveTab] = useState(initialTab);

    const handleActiveTab = (tabValue) => {
        setActiveTab(tabValue);
        onTabChange(tabValue);
    };

    return (
        <div className='w-full flex justify-between items-center border-b pb-2 mb-4'>
            <div className='flex gap-6'>
                {tabList?.map((tab) => (
                    <button
                        key={tab?.value}
                        onClick={() => handleActiveTab(tab?.value)}
                        className={`flex items-center gap-2 pb-2  ${activeTab === tab?.value ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}
                    >
                        {tab?.icon}
                        {tab?.label}
                    </button>
                ))}
            </div>
            <div className='flex gap-3 items-center'>
                {activeTab === 'viewSchedule' && Object.keys(filters).length > 0 && filters?.multiStore?.id?.length > 0 && filtersInfoChip(filtersInfo, filters)}
                {buttonList?.map((btn, index) => {
                    return (
                        <button
                            key={index}
                            onClick={btn?.onClick}
                            className={`flex items-center gap-2 py-2 px-4 rounded-md text-sm font-medium shadow-sm ${btn?.cssTailwind}`}
                        >
                            {btn?.icon}
                            {btn?.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
